import { emotionsReady } from '@polyv/emotion-sdk';

export default {
  data() {
    return {
      emotionsVisible: false,
      askContent: ''
    };
  },

  watch: {
    lang(value) {
      emotionsReady((parser) => {
        this.askContent = parser.translate(this.askContent, value);
      });
    }
  }
};
